import { createActions } from 'redux-actions';

const prefix = 'APP';
const actionTypes = [
  'TOGGLE_DRAWER',
  'SET_ONLINE',
  'SET_OFFLINE',
  'TOGGLE_SEARCH',
  'EXECUTE_SEARCH',
  'MARK_ERROR_HANDLED',
  'SET_PAGE_LOADING',
  'SET_NEXT_ROOT_COMPONENT',
  'TOGGLE_HEADER_ON_TOP',
  'SET_HEADER_TOOLBAR_HEIGHT',
  'SET_MOBILE_FILTER_BAR_FIXED_ON_TOP',
  'SET_HEADER_HEIGHT',
  'SET_ACTIVE_COLUMN',
  'SET_CART_ACTIVE_COLUMN',
];

export default createActions(...actionTypes, {
  prefix,
});
